import { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './Carousel.css';

export default function ImageCarousel({ images = [] }: { images: {url?: string, image: string}[] }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    if (!images?.length) {
        return <div className="carousel-empty">No images to display</div>;
    }

    const goToPrevious = () => setCurrentIndex(i => i === 0 ? images.length - 1 : i - 1);
    const goToNext = () => setCurrentIndex(i => i === images.length - 1 ? 0 : i + 1);
    const hasMultiple = images.length > 1;

    useEffect(() => {
        let interval = setInterval(() => {
            goToNext();
            console.log("NEXT");
        }, 5000);

        return () => {
            clearInterval(interval);
        }
    }, []);

    return (
        <div className="carousel">
            <div className="carousel-image-container">
                <a href={images[currentIndex].url || "#"}>
                    <img
                        src={images[currentIndex].image}
                        alt={`Slide ${currentIndex + 1}`}
                        className="carousel-image"
                    />
                </a>

                {hasMultiple && (
                    <>
                        <button
                            onClick={goToPrevious}
                            className="carousel-arrow carousel-arrow-left"
                            aria-label="Previous image"
                        >
                            <ChevronLeft size={16} />
                        </button>

                        <button
                            onClick={goToNext}
                            className="carousel-arrow carousel-arrow-right"
                            aria-label="Next image"
                        >
                            <ChevronRight size={16} />
                        </button>
                    </>
                )}
            </div>

        </div>
    );
};